// src/components/Layout/VoiceBotHeader.js (updated)
import React, { useEffect, useState } from "react";
import { TbArrowsDiagonal } from "react-icons/tb";
import { FiLogOut } from "react-icons/fi";
import * as RiIcons from "react-icons/ri";
import * as FaIcons from "react-icons/fa";
import femaleIcon from "../../assets/female2.png";
import maleIcon from "../../assets/male.svg";
import LanguageSelector from "./LanguageSelector"; // Import the language selector
import { useStaticTranslations } from "../../utils/staticTranslations";
import { useLanguage } from "../../contexts/LanguageContext";

const VoiceBotHeader = ({
  isInChat,
  handleBackClick,
  isLoggedIn,
  handleLogout,
  isExpandedWindow,
  handleExpand,
  toggleChat,
  isPending,
  config,
  customBranding,
  showChatHistory,
  activeSection,
  selectedVoice,
  setSelectedVoice,
  isAiChat,
  supportedLanguages,
  hideBackButton,
}) => {
  const [chatbotData, setChatbotData] = useState(null);
  const [isVoiceToggleOn, setIsVoiceToggleOn] = useState(false);
  const { currentLanguage } = useLanguage();
  const { commonMessage } = useStaticTranslations(currentLanguage.code);

  // Voice options - just Aarav and Ananya as requested
  const voiceOptions = [
    { id: "hi-IN-AaravNeural", name: "Aarav (Male)" },
    { id: "hi-IN-AnanyaNeural", name: "Ananya (Female)" },
  ];

  useEffect(() => {
    const storedData = localStorage.getItem("chatBotData");
    if (storedData) {
      setChatbotData(JSON.parse(storedData));
    }
  }, []);

  // Update selected voice when toggle changes
  useEffect(() => {
    setSelectedVoice(
      isVoiceToggleOn ? "hi-IN-AnanyaNeural" : "hi-IN-AaravNeural"
    );
  }, [isVoiceToggleOn, setSelectedVoice]);

  return (
    <div
      className={`flex justify-between items-center ${
        isExpandedWindow ? "px-6 py-4" : "px-3 py-3"
      } ${isExpandedWindow ? "rounded-none" : "rounded-t-lg"}`}
      style={{
        backgroundColor: chatbotData?.color,
        color: customBranding.headerTextColor,
      }}
    >
      {/* Left section with back button and title */}
      <div className="flex items-center gap-2 flex-1">
        {!hideBackButton && (
          <button
            onClick={handleBackClick}
            className="p-0 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-300"
            disabled={isPending}
          >
            <RiIcons.RiArrowLeftLine size={18} />
          </button>
        )}
        <h2
          className={`font-semibold ${
            isExpandedWindow ? "text-xl" : "text-base"
          } `}
        >
          {showChatHistory
            ? commonMessage("chatHistory")
            : chatbotData?.name || config.name}
        </h2>
      </div>

      {/* Right section with voice toggle, language selector, and action buttons */}
      <div className="flex items-center">
        {/* Language Selector - Added here */}
        <LanguageSelector
          color={customBranding.headerTextColor}
          supportedLanguages={supportedLanguages}
        />

        {/* Voice Toggle Button - Only shown when talk section is active */}
        {activeSection === "talk" && (
          <button
            onClick={() => setIsVoiceToggleOn(!isVoiceToggleOn)}
            className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all duration-300"
            title={
              isVoiceToggleOn
                ? "Switch to Male Voice"
                : "Switch to Female Voice"
            }
            style={{ color: customBranding.headerTextColor }}
          >
            {isVoiceToggleOn ? (
              <img src={femaleIcon} alt="Female" className="w-4 h-4" />
            ) : (
              <img src={maleIcon} alt="Male" className="w-4 h-4" />
            )}
            <span className="text-sm font-medium">
              {isVoiceToggleOn ? "Female" : "Male"}
            </span>
          </button>
        )}

        {/* Action buttons - separated with subtle divider */}
        <div
          className={`flex items-center gap-1 ${
            activeSection === "talk"
              ? "pl-3 border-l border-white border-opacity-20"
              : ""
          }`}
        >
          {isLoggedIn && (
            <button
              onClick={handleLogout}
              className="p-1.5 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-300"
              title="Logout"
            >
              <FiLogOut size={16} />
            </button>
          )}
          {!isExpandedWindow && (
            <>
              <button
                onClick={handleExpand}
                className="p-1.5 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-300"
                title="Open in new window"
              >
                <TbArrowsDiagonal size={16} />
              </button>
              <button
                onClick={toggleChat}
                className="p-1.5 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-300"
                disabled={isPending}
              >
                <FaIcons.FaChevronDown size={16} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VoiceBotHeader;
